;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "$stateParams", "glError", "app", "chainService", "pageService", "moduleService", "elementsService", "elementSelector"];
  angular.module('app.page').controller('Page', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $state,
    $stateParams,
    glError,
    app,
    chainService,
    pageService,
    moduleService,
    elementsService,
    elementSelector
  ) {
    var States = {
      LOADING: 'loading',
      READY: 'ready',
    }

    init()

    function init() {
      setState(States.LOADING)

      pageService.get($stateParams.id).then(function(page) {
        $scope.page = page

        moduleService.getByPage(page.id).then(function(modules) {
          $scope.modules = modules

          getElementId(function(elementId) {
            chainService.update({
              pageId: page.id,
              elementId: elementId,
              linkId: $stateParams.linkId,
            })

            app.setTitle(page.title)

            setState(States.READY)
          })
        }, glError.internal)
      }, glError.notFound)
    }

    function getElementId(done) {
      if ($stateParams.elementId) {
        return done($stateParams.elementId)
      }

      elementsService.getByPage($scope.page.id).then(function(elements) {
        if (!elements.length) {
          return done()
        }

        if (elements.length === 1) {
          return done(elements[0].id)
        }

        elementSelector.prompt(elements).then(
          function(element) {
            done(element.id)
          },
          function() {
            done()
          }
        )
      }, glError.internal)
    }

    function setState(state) {
      $scope.state = state
    }
  }
})()
